import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Adal8Service } from 'adal-angular8';
import { BaseService } from '../../services/base.service';
import { ConstantsService } from '../../services/constants.service';
import { GlobalConstants } from '../../services/GlobalConstants.service';
@Component({
  selector: 'ara-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  logoAlert=GlobalConstants.AppName;
  logoSrc =GlobalConstants.LoginLogoPath;
  constructor(private baseService: BaseService,
    private adal4Service: Adal8Service,
    private translate: TranslateService) {

    const loggedInUser = this.baseService.getItemFromSession('loggedInUser');
    if (loggedInUser) {
      let redirectUri = ConstantsService.URL.APP + ConstantsService.URL.HOMEPAGE;
      window.open(redirectUri, '_self');
    }
    
     
  }

  ngOnInit() {
    if (this.adal4Service && this.adal4Service.userInfo && !this.adal4Service.userInfo.authenticated) {
      this.baseService.showRootLoader = false;
    }
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
  }

  openContractorLoginWindow() {
    sessionStorage.clear();
    this.baseService.navigateToUrl('contractorlogin');
  }
  getUserDomainDetails() {
    this.baseService.setItemInSession(ConstantsService.LoggedInUserType, ConstantsService.authenticationType.Employee);
    this.adal4Service.login();
  }
  fixLoginIssue(): void {
    localStorage.clear();
    window.location.reload();
  }
}
